import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Mail, ArrowRight, CheckCircle2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CustomerLoginPage() {
  const [email, setEmail] = React.useState("");
  const [sending, setSending] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  React.useEffect(() => {
    document.title = "Log ind på Min Side · EMA Kurer ApS";
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Indtast en gyldig email");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/auth/magic/request`, { email });
      setSent(true);
    } catch (err) {
      toast.error("Der opstod en fejl — prøv igen om lidt");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center px-5 py-16" data-testid="customer-login-page">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="kicker text-brand-red">Min Side · Selvbetjening</div>
          <h1 className="font-display font-bold text-3xl sm:text-4xl text-brand-dark mt-2">Log ind på din konto</h1>
          <p className="text-brand-text2 mt-3 text-sm leading-relaxed">
            Indtast din email — vi sender dig et sikkert login-link så du kan se din booking-historik og downloade dine fakturaer.
          </p>
        </div>

        {sent ? (
          <div className="bg-white border border-brand p-8 text-center" data-testid="login-sent">
            <CheckCircle2 size={48} className="mx-auto text-emerald-600" />
            <h2 className="font-display text-2xl text-brand-dark mt-4">Tjek din email</h2>
            <p className="text-brand-text2 mt-3 leading-relaxed">
              Hvis emailen findes i vores system, sender vi et login-link til
              <span className="block font-mono text-brand-dark mt-1">{email}</span>
              <span className="block text-xs mt-2">Linket virker i 30 minutter. Kig også i spam-mappen.</span>
            </p>
            <button onClick={() => { setSent(false); setEmail(""); }} className="text-brand-red font-semibold mt-6 text-sm hover:underline" data-testid="login-retry">
              Brug en anden email
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-brand p-8 space-y-4" data-testid="login-form">
            <div>
              <label className="label-flat flex items-center gap-2"><Mail size={12} /> Email</label>
              <input
                type="email"
                className="input-flat"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="din@email.dk"
                required
                autoFocus
                data-testid="login-email"
              />
            </div>
            <button type="submit" disabled={sending} className="btn-primary w-full justify-center" data-testid="login-submit">
              {sending ? <><Loader2 className="animate-spin" size={14} /> Sender link...</> : <>Send login-link <ArrowRight size={14} /></>}
            </button>
            <p className="text-xs text-brand-text2 text-center leading-relaxed pt-2">
              Ingen konto? Den oprettes automatisk når du booker din første levering på <Link to="/book" className="text-brand-red font-semibold">emakurer.dk/book</Link>
            </p>
          </form>
        )}

        <div className="text-center mt-6 text-sm text-brand-text2">
          <Link to="/" className="hover:text-brand-dark">← Tilbage til forsiden</Link>
        </div>
      </div>
    </div>
  );
}
